import styled from "./textarea.module.css"
function Textarea(props){
   //.log(props);
return(
<div className={styled.textareaWrapper}>
                <label>{props.label}</label>
                <textarea
                name={props.name}
                onChange={props.handleChange}
                 />
                 </div>
    );
}
export default Textarea;